import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { formatMinor } from "../../donation-form/composables/useCurrency";
const ABSENT = "–";
export function useCollecteMetricFormat() {
    const { locale } = useI18n();
    const countFormatter = computed(() => new Intl.NumberFormat(locale.value));
    function formatCount(count) {
        return Number.isFinite(count) ? countFormatter.value.format(count) : ABSENT;
    }
    function formatMoney(amountMinor, code) {
        return /^[A-Za-z]{3}$/.test(code ?? "") && Number.isFinite(amountMinor)
            ? formatMinor(amountMinor, code, locale.value)
            : ABSENT;
    }
    function formatWholeMoney(units, code) {
        return new Intl.NumberFormat(locale.value, {
            style: "currency",
            currency: code,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }).format(units);
    }
    return { formatCount, formatMoney, formatWholeMoney };
}
